import { render, staticRenderFns } from "./ArtistDetail.vue?vue&type=template&id=9f5e95c0&"
import script from "./ArtistDetail.vue?vue&type=script&lang=js&"
export * from "./ArtistDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArtistDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports